(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sillage-waitlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(value).padStart(2, '0');

    const bindFormInteraction = (root, formsApp, form, emailInput, submitButton) => {
      if (!form || !emailInput || !submitButton || form.dataset.sillageInteractionReady === 'true') return;
      form.dataset.sillageInteractionReady = 'true';

      let resetTimer = 0;
      const resetPendingState = () => {
        window.clearTimeout(resetTimer);
        form.dataset.sillagePending = 'false';
        submitButton.removeAttribute('aria-busy');
        submitButton.style.pointerEvents = '';
        submitButton.style.opacity = '';
        submitButton.style.cursor = '';
        const languageSuffix = root.lang === 'fr' ? 'Fr' : 'En';
        submitButton.textContent = formsApp.dataset[`button${languageSuffix}`] || '';
      };

      form.addEventListener('submit', (event) => {
        if (form.dataset.sillagePending === 'true') {
          event.preventDefault();
          return;
        }

        const email = emailInput.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;

        form.dataset.sillagePending = 'true';
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.style.pointerEvents = 'none';
        submitButton.style.opacity = '0.78';
        submitButton.style.cursor = 'wait';
        submitButton.textContent = `${submitButton.textContent.trim()}…`;
        resetTimer = window.setTimeout(resetPendingState, 12000);
      });

      emailInput.addEventListener('input', () => {
        if (form.dataset.sillagePending === 'true') resetPendingState();
      });

      window.addEventListener('pageshow', resetPendingState);

      const errorObserver = new MutationObserver(() => {
        if (form.dataset.sillagePending !== 'true') return;
        if (form.querySelector('[role="alert"], [aria-invalid="true"]')) resetPendingState();
      });
      errorObserver.observe(form, { attributes: true, childList: true, subtree: true, attributeFilter: ['aria-invalid'] });
    };

    const startCountdown = (countdown) => {
      const target = new Date(countdown.dataset.target).getTime();
      if (Number.isNaN(target)) return;

      const update = () => {
        const remaining = Math.max(0, target - Date.now());
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        countdown.querySelector('[data-days]').textContent = pad(days);
        countdown.querySelector('[data-hours]').textContent = pad(hours);
        countdown.querySelector('[data-minutes]').textContent = pad(minutes);
        countdown.querySelector('[data-seconds]').textContent = pad(seconds);
      };

      update();
      window.setInterval(update, 1000);
    };

    const setLanguage = (root, language) => {
      const nextLanguage = language === 'fr' ? 'fr' : 'en';
      root.lang = nextLanguage;

      root.querySelectorAll('[data-sillage-copy]').forEach((element) => {
        element.textContent = element.dataset[nextLanguage] || element.dataset.en || '';
      });

      root.querySelectorAll('[data-placeholder-fr]').forEach((element) => {
        element.placeholder = element.dataset[`placeholder${nextLanguage === 'en' ? 'En' : 'Fr'}`] || '';
      });

      root.querySelectorAll('[data-aria-fr]').forEach((element) => {
        element.setAttribute('aria-label', element.dataset[`aria${nextLanguage === 'en' ? 'En' : 'Fr'}`] || '');
      });

      root.querySelectorAll('[data-sillage-language]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.sillageLanguage === nextLanguage));
      });

      const formsApp = root.querySelector('[data-sillage-forms-app]');
      if (formsApp) {
        const embed = formsApp.querySelector('shopify-forms-embed');
        const formsScope = embed?.shadowRoot || formsApp;
        const emailInput = formsScope.querySelector('input[type="email"], input[inputmode="email"], [data-testid="field-email"]');
        const emailLabel = formsScope.querySelector('label[for="email"]');
        const submitButton = formsScope.querySelector('button[type="submit"]');
        const form = formsScope.querySelector('form');
        const formRoot = formsScope.querySelector('[data-form-root="true"]');
        const formDialog = formsScope.querySelector('[role="dialog"]');
        const formInline = formDialog?.parentElement;
        const formContainer = formInline?.parentElement;
        const formLayout = formContainer?.parentElement;
        const formImage = formDialog?.firstElementChild;
        const formField = emailInput?.parentElement;
        const placeholder = formsApp.dataset[`placeholder${nextLanguage === 'en' ? 'En' : 'Fr'}`] || '';
        const buttonLabel = formsApp.dataset[`button${nextLanguage === 'en' ? 'En' : 'Fr'}`] || '';
        if (emailInput && emailInput.placeholder !== placeholder) emailInput.placeholder = placeholder;
        if (emailLabel && emailLabel.textContent.trim() !== placeholder) emailLabel.textContent = placeholder;
        if (submitButton && form?.dataset.sillagePending !== 'true' && submitButton.textContent.trim() !== buttonLabel) submitButton.textContent = buttonLabel;

        bindFormInteraction(root, formsApp, form, emailInput, submitButton);

        if (embed && formDialog && submitButton && window.matchMedia('(max-width: 749px)').matches && embed.dataset.sillageMobileReady !== 'true') {
          embed.dataset.sillageMobileReady = 'true';
          embed.style.display = 'block';
          embed.style.width = '100%';
          embed.style.maxWidth = 'none';
          embed.style.setProperty('--inline-container-max-width', '100%');
          embed.style.setProperty('--container-max-w', '100%');

          if (formDialog) {
            formDialog.style.display = 'block';
            formDialog.style.gridTemplateColumns = 'minmax(0, 1fr)';
          }
          if (formLayout) {
            formLayout.style.gridTemplateColumns = 'minmax(0, 1fr)';
            formLayout.style.justifyContent = 'stretch';
          }
          if (formImage && formImage !== form?.parentElement) formImage.style.display = 'none';

          [formRoot, formLayout, formContainer, formInline, formDialog, form?.parentElement, form, formField, emailInput, submitButton].forEach((element) => {
            if (!element) return;
            element.style.width = '100%';
            element.style.maxWidth = 'none';
            element.style.minWidth = '0';
            element.style.marginLeft = '0';
            element.style.marginRight = '0';
            element.style.justifySelf = 'stretch';
            element.style.boxSizing = 'border-box';
          });
        }
      }

      try {
        window.localStorage.setItem('sillage-language', nextLanguage);
      } catch (error) {
        return;
      }
    };

    const setConfirmationState = (root) => {
      const signupView = root.querySelector('[data-sillage-signup-view]');
      const confirmationView = root.querySelector('[data-sillage-confirmation-view]');
      const postedSuccessfully = Boolean(root.querySelector('[data-sillage-posted-successfully]'));
      const queryConfirmed = new URLSearchParams(window.location.search).get('sillage_joined') === '1';
      const showConfirmation = postedSuccessfully || queryConfirmed;

      if (showConfirmation) {
        signupView.hidden = true;
        confirmationView.hidden = false;
        confirmationView.setAttribute('role', 'status');
        confirmationView.setAttribute('aria-live', 'polite');
      }
    };

    document.querySelectorAll('[data-sillage-waitlist]').forEach((root) => {
      root.querySelectorAll('[data-sillage-countdown]').forEach(startCountdown);
      setConfirmationState(root);

      let savedLanguage = '';
      try {
        savedLanguage = window.localStorage.getItem('sillage-language') || '';
      } catch (error) {
        savedLanguage = '';
      }

      const initialLanguage = savedLanguage === 'fr' ? 'fr' : 'en';
      setLanguage(root, initialLanguage);

      const formsApp = root.querySelector('[data-sillage-forms-app]');
      if (formsApp) {
        const observer = new MutationObserver(() => setLanguage(root, root.lang));
        observer.observe(formsApp, { childList: true, subtree: true });
        [100, 300, 800, 1600, 3000].forEach((delay) => {
          window.setTimeout(() => setLanguage(root, root.lang), delay);
        });
      }

      root.querySelectorAll('[data-sillage-language]').forEach((button) => {
        button.addEventListener('click', () => setLanguage(root, button.dataset.sillageLanguage));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
